import PropTypes from 'prop-types'
import { forwardRef, memo, useMemo } from 'react'
import useFallbackRef from 'lib/react/hooks/useFallbackRef'
import classNames from 'lib/util/classNames'
import styles from './Section.module.scss'

/**
 * The `Section`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
const Section = forwardRef((props, forwardedRef) => {
  const { Tag, children, className, ...rest } = props
  const ref = useFallbackRef(forwardedRef)
  const classNameOutput = useMemo(
    () => classNames(className, styles.container),
    [className]
  )

  return (
    <Tag ref={ref} className={classNameOutput} {...rest}>
      {children}
    </Tag>
  )
})

// Display name
Section.displayName = 'Section'

/** @type {object} */
Section.propTypes = {
  children: PropTypes.node,
  Tag: PropTypes.elementType,
  className: PropTypes.string
}

/** @type {object} */
Section.defaultProps = {
  Tag: 'section',
  className: ''
}

// Memoize
export default memo(Section)
